/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TenantEntity } from './TenantEntity';
import {
    TenantEntityFromJSON,
    TenantEntityFromJSONTyped,
    TenantEntityToJSON,
    TenantEntityToJSONTyped,
} from './TenantEntity';
import type { UserEntity } from './UserEntity';
import {
    UserEntityFromJSON,
    UserEntityFromJSONTyped,
    UserEntityToJSON,
    UserEntityToJSONTyped,
} from './UserEntity';

/**
 * 
 * @export
 * @interface ClientAccessTokenEntity
 */
export interface ClientAccessTokenEntity {
    /**
     * ID
     * @type {string}
     * @memberof ClientAccessTokenEntity
     */
    id: string;
    /**
     * トークン名
     * @type {string}
     * @memberof ClientAccessTokenEntity
     */
    tokenName: string;
    /**
     * トークンの説明
     * @type {string}
     * @memberof ClientAccessTokenEntity
     */
    description: string;
    /**
     * スコープ
     * @type {string}
     * @memberof ClientAccessTokenEntity
     */
    scope: string;
    /**
     * 取消フラグ
     * @type {boolean}
     * @memberof ClientAccessTokenEntity
     */
    revoked: boolean;
    /**
     * 発行日
     * @type {Date}
     * @memberof ClientAccessTokenEntity
     */
    issuedAt: Date;
    /**
     * 有効期限
     * @type {Date}
     * @memberof ClientAccessTokenEntity
     */
    expiresAt: Date;
    /**
     * テナント
     * @type {TenantEntity}
     * @memberof ClientAccessTokenEntity
     */
    tenant: TenantEntity;
    /**
     * ユーザー
     * @type {UserEntity}
     * @memberof ClientAccessTokenEntity
     */
    user: UserEntity;
    /**
     * 作成日時
     * @type {Date}
     * @memberof ClientAccessTokenEntity
     */
    createdAt: Date;
    /**
     * 最終更新日時
     * @type {Date}
     * @memberof ClientAccessTokenEntity
     */
    updatedAt: Date;
    /**
     * 作成ユーザー
     * @type {UserEntity}
     * @memberof ClientAccessTokenEntity
     */
    createdBy: UserEntity;
    /**
     * 最終更新ユーザー
     * @type {UserEntity}
     * @memberof ClientAccessTokenEntity
     */
    updatedBy: UserEntity;
}

/**
 * Check if a given object implements the ClientAccessTokenEntity interface.
 */
export function instanceOfClientAccessTokenEntity(value: object): value is ClientAccessTokenEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tokenName' in value) || value['tokenName'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    if (!('revoked' in value) || value['revoked'] === undefined) return false;
    if (!('issuedAt' in value) || value['issuedAt'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('tenant' in value) || value['tenant'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    return true;
}

export function ClientAccessTokenEntityFromJSON(json: any): ClientAccessTokenEntity {
    return ClientAccessTokenEntityFromJSONTyped(json, false);
}

export function ClientAccessTokenEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientAccessTokenEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tokenName': json['tokenName'],
        'description': json['description'],
        'scope': json['scope'],
        'revoked': json['revoked'],
        'issuedAt': (new Date(json['issuedAt'])),
        'expiresAt': (new Date(json['expiresAt'])),
        'tenant': TenantEntityFromJSON(json['tenant']),
        'user': UserEntityFromJSON(json['user']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'createdBy': UserEntityFromJSON(json['createdBy']),
        'updatedBy': UserEntityFromJSON(json['updatedBy']),
    };
}

export function ClientAccessTokenEntityToJSON(json: any): ClientAccessTokenEntity {
    return ClientAccessTokenEntityToJSONTyped(json, false);
}

export function ClientAccessTokenEntityToJSONTyped(value?: ClientAccessTokenEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tokenName': value['tokenName'],
        'description': value['description'],
        'scope': value['scope'],
        'revoked': value['revoked'],
        'issuedAt': ((value['issuedAt']).toISOString()),
        'expiresAt': ((value['expiresAt']).toISOString()),
        'tenant': TenantEntityToJSON(value['tenant']),
        'user': UserEntityToJSON(value['user']),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'createdBy': UserEntityToJSON(value['createdBy']),
        'updatedBy': UserEntityToJSON(value['updatedBy']),
    };
}

